<template>
  <div class="createPopupContainer flexContainer columnContainer">
    <button
      @click="closePopup"
      class="closeButton bigText"
      style="color: #ec783e"
    >
      x
    </button>
    <p class="mediumText">
      A więc chcesz współtworzyć Wademekum. Nic prostszego:
    </p>
    <p
      class="mediumText"
      style="line-height: 1.5em; width: 80%; align-self: center"
      v-html="howToCreateMessage"
    ></p>
    <p class="smallText" style="line-height: 1.5em">
      Klauzula o inteligencji i odpowiedzialności:<br />
      Współtworząc Przewodnik po krajobrazie mentalnym, przyznajesz, że jesteś
      inteligentną istotą, a co za tym idzie, ponosisz odpowiedzialność nie
      tylko za to bierzesz do siebie, ale również za to co dajesz innym.
    </p>
    <button
      class="linkAlike mediumText"
      style="align-self: center; color: #ec783e"
      @click="closePopup"
    >
      Wspaniale!
    </button>
  </div>
</template>

<script>
import rangy from "rangy";

export default {
  computed: {
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    howToCreateMessage() {
      if (this.isMobile) {
        return "Kliknij dwukrotnie w wybrane przez Ciebie słowa w artykule, który akurat czytasz, aby stworzyć link do nowego artykułu Twojego autorstwa. Daj mu tytuł i treść - napisz tekst lub załącz plik.";
      } else {
        return (
          '<span id="selectMarker">Zaznacz</span> wybrany przez Ciebie fragment\n' +
          "      artykułu, który akurat czytasz, aby aby stworzyć link do nowego artykułu\n" +
          "      Twojego autorstwa. Daj mu tytuł i treść - napisz tekst lub załącz plik.\n" +
          "      Wspaniale!"
        );
      }
    },
  },
  methods: {
    closePopup() {
      this.$store.dispatch("deletePopupMessage");
    },
    createSelection() {
      let selection = rangy.getSelection();
      let range = rangy.createRange();
      let selectElement = document.getElementById("selectMarker");
      range.selectNode(selectElement);
      selection.setSingleRange(range);
    },
  },
  mounted() {
    if (!this.isMobile) {
      this.createSelection();
    }
  },
};
</script>

<style scoped>
.createPopupContainer {
  width: 40%;
  height: 40%;
  margin-top: 15%;
  margin-left: 23%;
  border: 2px solid #e27000;
  background-color: #ffffff;
  padding: 0.5%;
  box-shadow: 0 0 0 4px #ffffff, 0 0 0 6px #000000;
}

p {
  margin: 2%;
}

@media (max-width: 1000px) {
  .createPopupContainer {
    margin-top: 15%;
    margin-left: 5%;
    width: 80%;
    height: 60%;
    justify-content: space-between;
    padding: 3%;
  }
}
</style>
